import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'consentButton'
})
export class ConsentButtonPipe implements PipeTransform {
  constructor(private user: UserService) {}

  transform(button: any, property: string): any {
    if (!button) return '';

    switch (property) {
      case 'label':
        if (!button.label) return '';
        const currentLanguage = this.user.getCurrentLanguage();
        return button.label[currentLanguage] || button.label['en'] || '';

      case 'class':
        // Generate class names for button-style-generator mixin
        // Pattern: {type}-button or {type}-button-outline
        const buttonType = button.type || 'primary'; // Default to 'primary' if not specified
        const baseClass = `${buttonType}-button`;
        
        if (button.style === 'outline') {
          return `${baseClass}-outline`;
        } else {
          return baseClass;
        }

      case 'type':
        return 'button';

      default:
        return '';
    }
  }
}

